import { accessKeys, catalogRolesKey, productsListKey } from '@/features/users'

// Products and catalog-role reads are shared with the users feature's Access
// tab — re-exported (not redefined) so both features hit the exact same
// react-query cache entry: a create/update/delete here invalidates the same
// key the Access tab's assign picker reads, and vice versa.
export { productsListKey, catalogRolesKey }

// The structure spine lives only here (the Access tab never reads it), but
// stays under the shared `access` namespace since it's keyed by the same
// per-product catalog concept.
export const productStructureKey = (product: string) => accessKeys.custom('productStructure', product)
